import { useNavigate, useParams } from 'react-router-dom';
import { Dialog, Modal } from '@oliasoft-open-source/react-ui-library';
import { TableViewer } from 'client/components/data-viewer/table-viewer/table-viewer';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { getResultEntityPath } from '../query-utils';

type TableModalProps = {
  data: IObject;
  visibleColumns: string[];
  onClose: () => void;
};

export const TableModal = ({ data, visibleColumns, onClose }: TableModalProps) => {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const onHeaderClick = () => {
    const archiveId = data.metadata?.hierarchyData.archive.id;
    const designId = data.metadata?.hierarchyData.design.id;
    navigate(getResultEntityPath(companyId, archiveId, designId));
  };
  return (
    <Modal visible centered>
      <Dialog
        dialog={{
          scroll: false,
          content: <TableViewer
            dataObject={data}
            visibleColumns={visibleColumns}
            onHeaderClick={onHeaderClick}
            setSelectedData={() => null}
            withPaste={false}
          />,
          onClose,
        }}
      />
    </Modal>
  );
};